// extracted by mini-css-extract-plugin
export default {"imgdiv":"_21136a2a9f _7299b4207c","img":"fd989c9257 _22215aae30"};